/* Forzono Atelier — theme.js (no dependencies) */
(function () {
  'use strict';

  var strings = window.themeStrings || {};
  var routes = window.themeRoutes || {};

  /* ---------- Announcement rotator ---------- */
  function initRotators(scope) {
    (scope || document).querySelectorAll('[data-rotator]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var items = el.querySelectorAll('.announcement__item');
      if (items.length < 2) return;
      var i = 0;
      var interval = parseInt(el.dataset.interval, 10) || 5000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ---------- Header: transparent -> solid on scroll ---------- */
  var DARK_SCENE = '[data-ring-story], .jr, .hero, .hero-film';            // full-bleed scenes the header may float over
  var DARK = DARK_SCENE + ', .scheme-dark';                       // acceptable first section for an overlay header
  // dark scenes' positions in the page, measured on load/resize (not on every scroll frame)
  var darkSpans = null;
  function measureDark() {
    var y = window.scrollY;
    darkSpans = [].map.call(document.querySelectorAll(DARK_SCENE), function (el) {
      var r = el.getBoundingClientRect(); return [r.top + y, r.bottom + y];
    });
  }
  function overDark() {
    if (!darkSpans) measureDark();
    var line = window.scrollY + 70;
    for (var i = 0; i < darkSpans.length; i++) if (darkSpans[i][0] <= line && darkSpans[i][1] >= line) return true;
    return false;
  }
  window.addEventListener('resize', function () { darkSpans = null; });
  window.addEventListener('load', function () { darkSpans = null; });
  if ('ResizeObserver' in window) document.addEventListener('DOMContentLoaded', function () {
    var main = document.getElementById('MainContent');
    if (main) new ResizeObserver(function () { darkSpans = null; }).observe(main);
  });
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var announcement = document.querySelector('.section-announcement');
    var root = document.documentElement;
    var ticking = false;

    // Overlay the homepage header only when the first section is a dark scene; otherwise white header text
    // would sit on a light section (e.g. if the merchant removes or reorders the 3D hero).
    var noOverlay = false;
    function evalOverlay() {
      var main = document.getElementById('MainContent');
      var first = main && main.querySelector('.shopify-section');
      var firstDark = !!(first && (first.matches(DARK) || first.querySelector(DARK)));
      noOverlay = header.classList.contains('header--transparent') && !firstDark;
      root.classList.toggle('header-no-overlay', noOverlay);
    }

    // Root-level custom properties restyle the whole page when they change, so they are written
    // only when their value actually changes (never on every scroll frame).
    var lastVars = {};
    function setVar(name, val) { if (lastVars[name] !== val) { lastVars[name] = val; root.style.setProperty(name, val); } }
    var annH = 0;
    function setAnnHeight() {
      annH = announcement ? announcement.offsetHeight : 0;
      setVar('--ann-h', annH + 'px');
      var hh = header.offsetHeight + 'px';
      if (lastVars['--header-h'] !== hh) { setVar('--header-h', hh); document.dispatchEvent(new CustomEvent('fz:header-h')); }
    }
    setAnnHeight();
    window.addEventListener('resize', setAnnHeight);
    if ('ResizeObserver' in window) new ResizeObserver(function () { setAnnHeight(); }).observe(header);
    evalOverlay();
    function update() {
      var y = window.scrollY;                                            // reads first
      var solid = header.classList.contains('header--transparent')
        ? (noOverlay || (y > 40 && !overDark()) || header.querySelector('details[open]') !== null)  // stay transparent while a dark scene is under the header
        : null;
      setVar('--announcement-height', Math.max(0, annH - y) + 'px');     // then writes
      if (solid !== null && header.classList.contains('is-solid') !== solid) header.classList.toggle('is-solid', solid);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update);
    header.addEventListener('toggle', update, true);
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(function () { blendSections(); evalOverlay(); setAnnHeight(); update(); }, 50); });
    });
    update();

    // Close drawer/search on Escape or outside click
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      header.querySelectorAll('details[open]').forEach(function (d) { d.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) {
      header.querySelectorAll('details[data-search][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    var search = header.querySelector('[data-search]');
    if (search) {
      search.addEventListener('toggle', function () {
        if (search.open) { var input = search.querySelector('input[type="search"]'); if (input) input.focus(); }
      });
    }
    var drawer = header.querySelector('[data-drawer]');
    if (drawer) {
      var toggle = drawer.querySelector('summary');
      drawer.addEventListener('toggle', function () {
        var open = drawer.open;
        document.body.style.overflow = open ? 'hidden' : '';
        if (window.__lenis) { if (open) window.__lenis.stop(); else window.__lenis.start(); }
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var first = drawer.querySelector('.drawer__menu a, .drawer__menu summary');
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
        } else if (toggle && drawer.contains(document.activeElement)) {
          toggle.focus({ preventScroll: true });
        }
      });
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-drawer-close]')) drawer.removeAttribute('open');
      });
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  }

  /* ---------- Blend light/dark section hand-offs ---------- */
  function bgOf(el) {
    var cs = getComputedStyle(el);
    var v = cs.getPropertyValue('--section-bg').trim();
    if (el.matches('.scheme-dusk, .jr, [data-ring-story], .hero, .hero-film')) v = getComputedStyle(document.documentElement).getPropertyValue('--atelier-bg').trim() || '#100904';
    if (!v || v === 'transparent') v = cs.backgroundColor;
    return v;
  }
  function lum(color) {
    var probe = document.createElement('span');
    probe.style.color = color; document.body.appendChild(probe);
    var m = getComputedStyle(probe).color.match(/[\d.]+/g) || [0, 0, 0];
    probe.remove();
    return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
  }
  function blendSections() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var prev = null;
    [].forEach.call(main.querySelectorAll(':scope > .shopify-section'), function (wrap) {
      var el = wrap.querySelector('.section, .jr, [data-ring-story], .hero-film, .hero');
      if (!el) { prev = null; return; }
      el.classList.remove('blend-top', 'blend-top--soft');
      if (prev) {
        var a = bgOf(prev), b = bgOf(el);
        var la = lum(a), lb = lum(b);
        if (Math.abs(la - lb) > 0.25 && el.classList.contains('section')) {
          el.style.setProperty('--blend-from', a);
          el.classList.add('blend-top');
          el.classList.toggle('blend-top--soft', la > lb); // light into dark: a short, faint hand-off rather than a haze
        }
      }
      prev = el;
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    if (!document.body.classList.contains('has-reveal')) return;
    var els = (scope || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(message) {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4500);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-product]').forEach(function (section) {
      if (section.dataset.bound) return;
      section.dataset.bound = '1';

      var jsonEl = section.querySelector('[data-product-json]');
      var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      var form = section.querySelector('[data-product-form]');
      var select = section.querySelector('[data-variant-select]');
      var addBtn = section.querySelector('[data-add-button]');
      var addLabel = section.querySelector('[data-add-label]');
      var priceWrap = section.querySelector('[data-price] .price');
      var errorEl = section.querySelector('[data-form-error]');

      // Gallery thumbs
      function showMedia(id) {
        if (!id) return;
        section.querySelectorAll('.product__slide').forEach(function (s) {
          s.classList.toggle('is-active', String(s.dataset.mediaId) === String(id));
        });
        section.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', String(t.dataset.thumb) === String(id));
        });
      }
      section.querySelectorAll('[data-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () { showMedia(btn.dataset.thumb); });
      });

      // Quantity
      section.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = btn.parentElement.querySelector('input');
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
          input.value = next;
        });
      });

      // Variants
      var radios = section.querySelectorAll('[data-variants] input[type="radio"]');
      function formatMoney(cents) {
        var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
        } catch (e) { return (cents / 100).toFixed(2); }
      }
      function onVariantChange() {
        if (!product) return;
        var selected = [];
        section.querySelectorAll('[data-variants] fieldset').forEach(function (fs, idx) {
          var checked = fs.querySelector('input:checked');
          selected[idx] = checked ? checked.value : null;
          var label = section.querySelector('[data-option-label="' + idx + '"]');
          if (label && checked) label.textContent = checked.value;
        });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        if (!variant) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = strings.unavailable || 'Unavailable';
          return;
        }
        if (select) select.value = variant.id;
        if (addBtn) addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? (strings.addToCart || 'Add to bag') : (strings.soldOut || 'Sold out');
        section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
        if (priceWrap) {
          var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
            priceWrap.classList.add('price--sale');
          } else {
            priceWrap.classList.remove('price--sale');
          }
          priceWrap.innerHTML = html;
        }
        if (variant.featured_media) showMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      radios.forEach(function (r) { r.addEventListener('change', onVariantChange); });

      // AJAX add to cart (falls back to normal submit without fetch)
      if (form && window.fetch) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (errorEl) errorEl.hidden = true;
          addBtn.disabled = true;
          fetch(routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          })
            .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
            .then(function (result) {
              if (!result.ok) throw new Error(result.data.description || result.data.message || 'Error');
              return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
            })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              showToast(strings.added || 'Added to your bag');
            })
            .catch(function (err) {
              if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
            })
            .finally(function () { addBtn.disabled = false; });
        });
      }
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(scope) {
    (scope || document).querySelectorAll('[data-recommendations]').forEach(function (el) {
      if (el.dataset.bound || !el.dataset.url || el.children.length) return;
      el.dataset.bound = '1';
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            initReveal(el);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Misc ---------- */
  function initMisc(scope) {
    (scope || document).querySelectorAll('[data-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () { el.form.submit(); });
    });
    (scope || document).querySelectorAll('[data-toggle-recover]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var recover = document.getElementById('Recover');
        var login = document.getElementById('Login');
        if (!recover || !login) return;
        var showRecover = recover.hidden;
        recover.hidden = !showRecover;
        login.hidden = showRecover;
      });
    });
    if (window.location.hash === '#recover') {
      var r = document.getElementById('Recover'), l = document.getElementById('Login');
      if (r && l) { r.hidden = false; l.hidden = true; }
    }
  }

  /* ---------- Catalogue shell: category tabs + featured pieces drive one iframe ---------- */
  function initCatalogue(scope) {
    (scope || document).querySelectorAll('[data-catalogue-frame]').forEach(function (frame) {
      if (frame.dataset.bound) return;
      frame.dataset.bound = '1';
      var root = frame.closest('.catalogue') || frame.parentElement;
      var iframe = frame.querySelector('iframe');
      var tabs = root.querySelectorAll('[data-catalogue-tabs] .catalogue__tab[data-src]');
      var pieces = root.querySelectorAll('[data-catalogue-piece]');
      var now = root.querySelector('[data-catalogue-now]');
      var nowTitle = now && now.querySelector('[data-now-title]');
      var home = frame.dataset.home || iframe.getAttribute('src');
      var done = function () { frame.classList.remove('is-loading'); };
      iframe.addEventListener('load', done);
      setTimeout(done, 8000);

      function scrollToFrame() {
        var anchor = now && !now.hidden ? now : (root.querySelector('[data-catalogue-tabs]') || frame);
        var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 84;
        var y = anchor.getBoundingClientRect().top + window.scrollY - headerH - 24;
        if (window.__lenis) window.__lenis.scrollTo(y); else window.scrollTo({ top: y, behavior: 'smooth' });
      }
      function load(src, key) {
        if (src && iframe.getAttribute('src') !== src) {
          frame.classList.add('is-loading');
          iframe.setAttribute('src', src);
          setTimeout(done, 8000);
        }
        if (window.history && history.replaceState) {
          history.replaceState(null, '', key && key !== 'all' ? '#' + key : window.location.pathname + window.location.search);
        }
      }
      function mark(el) {
        tabs.forEach(function (t) { var on = t === el; t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        pieces.forEach(function (p) { var on = p === el; p.classList.toggle('is-current', on); if (on) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current'); });
        var isPiece = !!(el && el.hasAttribute('data-catalogue-piece'));
        if (now) { now.hidden = !isPiece; if (isPiece && nowTitle) nowTitle.textContent = el.dataset.title || ''; }
      }
      function select(el, scroll) {
        mark(el);
        load(el.dataset.src, el.dataset.key);
        if (scroll) scrollToFrame();
      }
      function reset() {
        var all = root.querySelector('.catalogue__tab[data-key="all"]');
        if (all) { select(all, false); return; }
        mark(null);
        load(home, '');
      }
      tabs.forEach(function (tab) { tab.addEventListener('click', function () { select(tab, false); }); });
      pieces.forEach(function (piece) {
        piece.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let "open in new tab" work
          e.preventDefault();
          select(piece, true);
        });
      });
      var resetBtn = root.querySelector('[data-catalogue-reset]');
      if (resetBtn) resetBtn.addEventListener('click', function () { reset(); scrollToFrame(); });

      function fromHash(scroll) {
        var key = decodeURIComponent(window.location.hash.slice(1)).toLowerCase();
        if (!key || key === 'all') return;
        var targets = [].slice.call(tabs).concat([].slice.call(pieces));
        for (var i = 0; i < targets.length; i++) {
          if (targets[i].dataset.key === key) { select(targets[i], scroll); return; }
        }
      }
      fromHash(true);
      window.addEventListener('hashchange', function () { fromHash(true); });

      // Theme editor: selecting a piece block previews it in the frame
      document.addEventListener('shopify:block:select', function (e) {
        var link = e.target.querySelector && e.target.querySelector('[data-catalogue-piece]');
        if (link && root.contains(link)) select(link, false);
      });
    });
  }

  /* ---------- Policy page: highlight the chapter in view ---------- */
  function initPolicy(scope) {
    (scope || document).querySelectorAll('[data-policy]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var links = root.querySelectorAll('[data-policy-link]');
      if (!links.length) return;
      var mobile = root.querySelector('.policy-toc__mobile');
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var target = document.getElementById(a.getAttribute('href').slice(1));
          if (!target) return;
          e.preventDefault();
          if (mobile) mobile.removeAttribute('open');
          var y = target.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 84) - 20;
          if (window.__lenis) window.__lenis.scrollTo(y); else window.scrollTo({ top: y, behavior: 'smooth' });
          if (history.replaceState) history.replaceState(null, '', '#' + target.id);
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          current = en.target.id;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + current); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      root.querySelectorAll('.policy-chapter[id]').forEach(function (h) { io.observe(h); });
    });
  }

  /* ---------- Collection index: swap the preview image on hover/focus ---------- */
  function initCollectionIndex(scope) {
    (scope || document).querySelectorAll('[data-collection-index]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var visuals = root.querySelectorAll('[data-ci-visual]');
      var rows = root.querySelectorAll('[data-ci-row]');
      function show(i) {
        visuals.forEach(function (v) { v.classList.toggle('is-active', v.dataset.ciVisual === i); });
        rows.forEach(function (r) { r.classList.toggle('is-active', r.dataset.ciRow === i); });
      }
      rows.forEach(function (r) {
        r.addEventListener('mouseenter', function () { show(r.dataset.ciRow); });
        r.addEventListener('focus', function () { show(r.dataset.ciRow); });
      });
    });
  }

  /* ---------- In-page anchor links (education topics, homepage → #diamond-size) ---------- */
  function headerOffset() { return (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 84) + 16; }
  function scrollToEl(t) {
    // smooth-scroll already honours CSS scroll-margin-top; only add the header offset where none is set
    var margin = parseFloat(getComputedStyle(t).scrollMarginTop) || 0;
    if (window.__lenis) { window.__lenis.scrollTo(t, { offset: margin ? 0 : -headerOffset(), lock: true, force: true }); return; }
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - headerOffset(), behavior: 'smooth' });
  }
  function initAnchors() {
    if (document.documentElement.dataset.anchorsBound) return;
    document.documentElement.dataset.anchorsBound = '1';
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-anchor-link], a[href^="#"]');
      if (!a || a.hasAttribute('data-policy-link') || a.getAttribute('href') === '#') return;
      var href = a.getAttribute('href') || '';
      var i = href.indexOf('#');
      if (i === -1) return;
      var path = href.slice(0, i);
      if (path && path !== window.location.pathname) return; // another page: let the browser navigate
      var t = document.getElementById(decodeURIComponent(href.slice(i + 1)));
      if (!t) return;
      e.preventDefault();
      e.stopPropagation(); // smooth-scroll's own anchor handler has no header offset
      scrollToEl(t);
      if (history.replaceState) history.replaceState(null, '', '#' + t.id);
    }, true);
    // arriving from another page with a hash: correct for the sticky header once layout settles
    if (window.location.hash.length > 1) {
      var t = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      if (t) window.addEventListener('load', function () { setTimeout(function () { scrollToEl(t); }, 150); });
    }
  }

  /* ---------- Bag: update quantities and remove lines in place ---------- */
  function initCart(scope) {
    (scope || document).querySelectorAll('[data-cart]').forEach(function (root) {
      if (root.dataset.bound || !window.fetch) return;
      root.dataset.bound = '1';
      var sectionId = root.dataset.sectionId;
      var status = root.querySelector('[data-cart-status]');
      var busy = false;

      function change(line, quantity) {
        if (busy) return;
        busy = true;
        root.classList.add('is-updating');
        fetch((routes.cartChange || '/cart/change') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId], sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok || !res.data.sections || !res.data.sections[sectionId]) throw new Error(res.data && (res.data.description || res.data.message));
            var doc = new DOMParser().parseFromString(res.data.sections[sectionId], 'text/html');
            var fresh = doc.querySelector('[data-cart]');
            if (fresh) {
              root.innerHTML = fresh.innerHTML;
              root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
            }
            updateCartCount(res.data.item_count);
            root.dispatchEvent(new CustomEvent('cart:updated'));
            var msg = root.querySelector('[data-cart-status]');
            if (msg) msg.textContent = res.data.item_count + ' ' + (res.data.item_count === 1 ? 'item' : 'items') + ' in your bag';
          })
          .catch(function (err) {
            // fall back to a normal form update so the shopper is never stuck
            var form = root.querySelector('#CartForm');
            if (form) {
              var input = form.querySelector('[data-qty-input][data-line="' + line + '"]');
              if (input) input.value = quantity;
              var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; form.appendChild(u);
              form.submit();
            } else if (status) { status.textContent = (err && err.message) || 'Something went wrong. Please refresh the page.'; }
          })
          .then(function () { busy = false; root.classList.remove('is-updating'); });
      }

      root.addEventListener('click', function (e) {
        var step = e.target.closest('[data-qty-step]');
        if (step) {
          var input = step.closest('[data-qty]').querySelector('[data-qty-input]');
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
          var max = parseInt(input.getAttribute('max'), 10);
          if (!isNaN(max)) next = Math.min(next, max);
          input.value = next;
          change(parseInt(input.dataset.line, 10), next);
          return;
        }
        var remove = e.target.closest('[data-remove]');
        if (remove) {
          e.preventDefault();
          change(parseInt(remove.dataset.remove, 10), 0);
        }
      });

      root.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (input) change(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
      });

      // keep the gift note saved while the shopper types (it is also sent with checkout)
      var noteTimer;
      root.addEventListener('input', function (e) {
        if (!e.target.matches('[data-cart-note]')) return;
        clearTimeout(noteTimer);
        var value = e.target.value;
        noteTimer = setTimeout(function () {
          fetch((routes.cart || '/cart') + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: value }) });
        }, 500);
      });

      // mobile checkout bar: tuck it away while the main checkout button is on screen
      function watchBar() {
        var bar = root.querySelector('[data-cart-bar]');
        var main = root.querySelector('[data-checkout]');
        if (!bar || !main || !('IntersectionObserver' in window)) return;
        if (root._barObserver) root._barObserver.disconnect();
        root._barObserver = new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-hidden', entries[0].isIntersecting);
        });
        root._barObserver.observe(main);
      }
      watchBar();
      root.addEventListener('cart:updated', watchBar);

      // stop Enter in a quantity box from submitting the form to checkout
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('[data-qty-input]')) { e.preventDefault(); e.target.blur(); }
      });
    });
  }

  function init(scope) {
    initAnchors();
    initCollectionIndex(scope);
    initPolicy(scope);
    initCatalogue(scope);
    initRotators(scope);
    initReveal(scope);
    initProduct(scope);
    initRecommendations(scope);
    initMisc(scope);
    initCart(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    blendSections();
    initHeader();
    init(document);
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el.classList.contains('reveal')) el.classList.add('is-visible');
    if (el.classList.contains('announcement__item')) {
      el.parentElement.querySelectorAll('.announcement__item').forEach(function (i) { i.classList.remove('is-active'); });
      el.classList.add('is-active');
    }
  });
})();
